import React, {useState, useEffect} from 'react';
import {Container, Row, Col} from 'reactstrap';
import BtnSubmit from '../../../Shared/Buttons/BtnSubmit';
import BasicText from '../DebtPaymentComponents/basicText';
import BasicImage from '../DebtPaymentComponents/basicImage';
import {errorEnum} from '../DebtPaymentComponents/debtPaymentEnum';
import gaParams from '../../../../utilities/analytics/constants';
import {gaEvent} from '../../../../utilities/analytics/tracking';
import Config from '../../../../Config';
import {numWithStarRTL} from '../../../../utilities/StringHelpers/StringHelpers';
import {CSSTransition} from 'react-transition-group';

import '../debtPayment.scss';
import '../debtPaymentAnimations.scss';

const NoAccountsError = (props) => {
  const [mount, setMount] = useState(false);

  let mainImg = require('../images/icons-almost-done-like.svg');

  let errorMsg = props.error.message && props.error.message !== '' ? props.error.message : 'מצטרעים, משהו קרה, אנא נסה שוב';

  useEffect(() => {
    if (props.currentStep === errorEnum.NOACCOUNTS) {
      setMount(true);
      gaEvent(
        gaParams.DEBT_PAYMENT_SHOW_COMPANYLIST_EMPTY.category,
        gaParams.DEBT_PAYMENT_SHOW_COMPANYLIST_EMPTY.eventType,
        gaParams.DEBT_PAYMENT_SHOW_COMPANYLIST_EMPTY.eventParams,
      );
    } else {
      setMount(false);
    }
  }, [props.currentStep]);

  return (
    <CSSTransition key={15} in={mount} timeout={250} classNames='stepwrapper' mountOnEnter unmountOnExit>
      <Container fluid className='debtpayment-step'>
        <Row className='debtpayment-container justify-content-md-center'>
          <Col md='auto'>
            <BasicText text='תשלום חוב' classname='debtpayment-title' />
          </Col>
        </Row>
        <Row className='debtpayment-step-title justify-content-md-center'>
          <Col md='auto'>
            <BasicText text={'אנחנו לא רואים חוב\n על המנוי הזה...'} classname={'main-text-extra-bold'} />
          </Col>
        </Row>
        <Row className='debtpayment-step-subtitle justify-content-md-center'>
          <Col md='auto'>
            <BasicText
              text={'אם לדעתכם יש חוב, אפשר ליצור קשר\n עם מוקד השירות שלנו ב-' + numWithStarRTL(Config.businessCallNumber) + ' ונברר זאת'}
            />
          </Col>
        </Row>
        <Row className='justify-content-md-center main-img'>
          <Col md='auto'>
            <BasicImage src={mainImg} />
          </Col>
        </Row>
        <Row className='justify-content-md-center footer-btn'>
          <Col md='auto'>
            <BtnSubmit isBusiness formid='' text='אוקי' onclick={props.onclick} />
          </Col>
        </Row>
      </Container>
    </CSSTransition>
  );
};

export default NoAccountsError;
